import { useEffect } from 'react'
import * as Sentry from '@sentry/react'

/**
 * Friendly full-page error state for route-level errors.
 * Replaces the previous `errorComponent: () => null`, which rendered a blank
 * white screen. Reload is the most reliable recovery for our audience.
 */
export default function RouteErrorScreen({ error }: { error?: unknown }) {
  useEffect(() => {
    if (error) {
      Sentry.captureException(error)
    }
  }, [error])

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">Something went wrong</h1>
        <p className="mt-3 text-base leading-relaxed text-slate-600">
          Don't worry, your account and your information are safe. This is a
          problem on our side, and we've been notified.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-6 w-full rounded-full bg-violet-600 px-6 py-3 text-base font-medium text-white hover:bg-violet-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600"
        >
          Try again
        </button>
        <a
          href="/"
          className="mt-4 inline-block py-2 text-base font-medium text-violet-700 underline underline-offset-4 hover:text-violet-800"
        >
          Go to my dashboard
        </a>
      </div>
    </div>
  )
}
